import { useContact } from "../../data/content";

function ContactMarquee() {
  const contact = useContact();
  const items = Array(5).fill(null);

  return (
    <div className="overflow-hidden">
      <div className="flex items-center animate-marquee-text w-max">
        {[...items, ...items].map((_, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-[11vw] leading-none text-text-primary-light dark:text-text-primary-dark whitespace-nowrap uppercase px-6">
              {contact.marqueeText}
            </span>
            <span className="text-[4vw] text-text-muted-light dark:text-text-muted-dark leading-none">
              •
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default ContactMarquee;
